(function () {
  if (window.__gmcBundleDeeplinkApplied) {
    return;
  }

  window.__gmcBundleDeeplinkApplied = true;

  var BUNDLES = {
    "1": {
      barIndex: 0,
      title: "1 Pouch with Recipe Ebook",
      price: "19.99",
      quantity: 1,
      description: "Includes 1 pouch of Ube Bae organic ube powder and the Ube 25 Recipe ebook."
    },
    "2": {
      barIndex: 1,
      title: "2 Pouches with Recipe Ebook and Frother",
      price: "33.99",
      quantity: 2,
      description: "Includes 2 pouches of Ube Bae organic ube powder, the Ube 25 Recipe ebook, and the Ube Bae handheld milk frother."
    },
    "3": {
      barIndex: 2,
      title: "3 Pouches with Recipe Ebook, Frother, and Straw",
      price: "44.99",
      quantity: 3,
      description: "Includes 3 pouches of Ube Bae organic ube powder, the Ube 25 Recipe ebook, the Ube Bae handheld milk frother, and the reusable stainless steel straw."
    }
  };

  var params = new URLSearchParams(window.location.search);
  var requestedBundle = params.get("bundle");
  var bundle = BUNDLES[requestedBundle];

  if (!bundle || window.location.pathname.replace(/\/$/, "") !== "/products/ube-powder") {
    return;
  }

  function clearRememberedBundleState() {
    ["localStorage", "sessionStorage"].forEach(function (storageName) {
      var storage;

      try {
        storage = window[storageName];
      } catch (error) {
        return;
      }

      if (!storage) {
        return;
      }

      for (var index = storage.length - 1; index >= 0; index -= 1) {
        var key = storage.key(index);
        var value = "";

        try {
          value = storage.getItem(key) || "";
        } catch (error) {
          value = "";
        }

        var storageText = key + " " + value;
        var looksLikeKachingState = /kaching/i.test(storageText);
        var looksLikeUbeBundleState = /bundle/i.test(key) && /ube-powder|pouch|frother|straw/i.test(value);

        if (looksLikeKachingState || looksLikeUbeBundleState) {
          try {
            storage.removeItem(key);
          } catch (error) {
            // Ignore storage permission errors. The click retry below still applies the URL selection.
          }
        }
      }
    });
  }

  function findBundleBars() {
    return Array.prototype.slice.call(document.querySelectorAll(".kaching-bundles__bar")).filter(function (bar) {
      return /pouch/i.test(bar.textContent || "");
    });
  }

  function findRequestedBundleBar() {
    var bars = findBundleBars();
    var quantityPattern = new RegExp("(^|\\D)" + requestedBundle + "\\s*pouches?", "i");
    var exactMatch = bars.filter(function (bar) {
      return quantityPattern.test(bar.textContent || "");
    })[0];

    return exactMatch || bars[bundle.barIndex];
  }

  function isBarSelected(bar) {
    var input = bar && bar.querySelector("input[type='radio'], input[type='checkbox']");
    var selectedNode = bar && (
      bar.matches("[aria-checked='true'], [aria-selected='true']") ||
      bar.querySelector("[aria-checked='true'], [aria-selected='true'], input:checked")
    );
    var selectedClass = bar && /(selected|active|checked)/i.test(bar.className || "");

    return Boolean((input && input.checked) || selectedNode || selectedClass);
  }

  function clickBar(bar) {
    var clickable =
      bar.querySelector("input, button, [role='radio'], .kaching-bundles__bar-container") ||
      bar;

    if (clickable.tagName === "INPUT") {
      clickable.checked = true;
      clickable.dispatchEvent(new Event("input", { bubbles: true }));
      clickable.dispatchEvent(new Event("change", { bubbles: true }));
    }

    clickable.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true, view: window }));
    bar.setAttribute("data-gmc-bundle-selected", "true");
  }

  function selectBundleBar() {
    var bar = findRequestedBundleBar();

    if (!bar) {
      return false;
    }

    if (!isBarSelected(bar)) {
      clickBar(bar);
    }

    return true;
  }

  function upsertOfferContext() {
    var root = document.querySelector(".kaching-bundles__block") || document.querySelector("kaching-bundle");

    if (!root) {
      return false;
    }

    var context = document.getElementById("gmc-bundle-offer-context");
    if (!context) {
      context = document.createElement("div");
      context.id = "gmc-bundle-offer-context";
      context.style.cssText = "margin:10px 0 12px;font-size:14px;line-height:1.45;color:#111827;";
      root.parentNode.insertBefore(context, root);
    }

    context.textContent = bundle.title + " - $" + bundle.price + " USD. " + bundle.description;
    return true;
  }

  function rewriteProductJsonLd() {
    var offerUrl = window.location.href;

    Array.prototype.slice.call(document.querySelectorAll('script[type="application/ld+json"]')).forEach(function (script) {
      var data;

      try {
        data = JSON.parse(script.textContent);
      } catch (error) {
        return;
      }

      if (!data || data["@type"] !== "Product" || !data.offers) {
        return;
      }

      data.name = "Ube Bae Organic Ube Powder Bundle - " + bundle.title;
      data.description = bundle.description;
      data.url = offerUrl;

      if (data.offers && !Array.isArray(data.offers)) {
        data.offers.price = bundle.price;
        data.offers.priceCurrency = "USD";
        data.offers.url = offerUrl;
        data.offers.availability = data.offers.availability || "https://schema.org/InStock";
      }

      script.textContent = JSON.stringify(data);
    });
  }

  function trySelect(attempt, startedAt) {
    var selected = selectBundleBar();
    var contextReady = upsertOfferContext();
    rewriteProductJsonLd();

    if (selected && contextReady && isBarSelected(findRequestedBundleBar()) && Date.now() - startedAt > 3000) {
      document.documentElement.setAttribute("data-gmc-bundle", requestedBundle);
      return;
    }

    if (attempt < 80) {
      window.setTimeout(function () {
        trySelect(attempt + 1, startedAt);
      }, 250);
    }
  }

  clearRememberedBundleState();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      trySelect(0, Date.now());
    });
  } else {
    trySelect(0, Date.now());
  }
})();
